import { usePageNumberFromUrl } from 'idsk-react-components';
import { useParams } from 'react-router';
import SubjektBezPripomienokListPage from '../../../model/subjektbezpripomienok/SubjektBezPripomienokListPage';
import { ClientStatus } from '../../../model/ClientStatus';
import { useClientFetch } from '../../../context/ClientStatusContext';
import { fetchSubjektBezPripomienokListPage } from '../../../client/subjektBezPripomienokClient';

interface ReturnType {
  subjektBezPripomienokListPage: SubjektBezPripomienokListPage;
  subjektStatus: ClientStatus;
  subjPageNumberFromUrl: number;
  reloadSubjektBezPripomienokList(): void;
}

export default (): ReturnType => {
  const { page } = usePageNumberFromUrl('pageSubj');
  const subjPageNumberFromUrl = page;
  // @ts-ignore
  const { type, year, index } = useParams<{ type: string, year: number, index: number }>();
  const {
    data: subjektBezPripomienokListPage,
    status: subjektStatus,
    refetch: reloadSubjektBezPripomienokList,
  } = useClientFetch(
    fetchSubjektBezPripomienokListPage,
    [type, year, index, page],
    [page],
  );
  // @ts-ignore
  return {
    subjektBezPripomienokListPage,
    subjektStatus,
    subjPageNumberFromUrl,
    reloadSubjektBezPripomienokList,
  };
};
